import { Color } from 'assets/theme/colors';
import styled from 'styled-components/macro';

type LoaderProps={
size?: string;
}

export const LoaderWrapper=styled.div<LoaderProps>`
display: flex;
justify-content:center;
align-items: center;
width:100%;

.loader {
  width:${({size})=> size ?? '48px'};
  height: ${({size})=> size ?? '48px'};
  border: 3px dotted ${Color.storefrontTheme};
  border-style: solid solid dotted dotted;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader::after {
  content: '';  
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px dotted ${Color.storefrontTheme};
  border-style: solid solid dotted;
  width:${({size})=> size ? `calc(${size}/${2})`:'24px'};
  height: ${({size})=>size ? `calc(${size}/${2})`:'24px'};
  border-radius: 50%;
  animation: rotationBack .5s linear infinite;
  transform-origin: center center;
}
    
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
} 
@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
} 
`